<app-hero [title]="'Datenschutz'"></app-hero>

<section class="privacy-policy">
  <div class="container">
    <h1>Datenschutzerklärung</h1>
    <p>Zuletzt aktualisiert: 21. Februar 2025</p>

    <h2>1. Einleitung</h2>
    <p>Willkommen bei [Ihr Website-Name]. Wir verpflichten uns, Ihre Privatsphäre zu schützen und Ihre personenbezogenen Daten sicher zu behandeln.</p>

    <h2>2. Welche Informationen wir sammeln</h2>
    <ul>
      <li><strong>Personenbezogene Daten:</strong> Name, E-Mail-Adresse, Telefonnummer usw.</li>
      <li><strong>Nutzungsdaten:</strong> Besuchte Seiten, Verweildauer auf der Website usw.</li>
      <li><strong>Cookies:</strong> Wir verwenden Cookies, um die Benutzererfahrung zu verbessern.</li>
    </ul>

    <h2>3. Wie wir Ihre Informationen verwenden</h2>
    <p>Wir verwenden Ihre Daten, um:</p>
    <ul>
      <li>Unsere Dienstleistungen bereitzustellen und zu verbessern</li>
      <li>Mit Ihnen zu kommunizieren</li>
      <li>Sicherheit zu gewährleisten und Betrug zu verhindern</li>
    </ul>

    <h2>4. Weitergabe an Dritte</h2>
    <p>Wir verkaufen Ihre personenbezogenen Daten nicht. Wir können sie jedoch mit vertrauenswürdigen Dritten teilen, um unsere Dienstleistungen zu verbessern.</p>

    <h2>5. Sicherheitsmaßnahmen</h2>
    <p>Wir setzen strenge Sicherheitsmaßnahmen ein, um Ihre Daten zu schützen.</p>

    <h2>6. Ihre Rechte</h2>
    <p>Sie haben das Recht, auf Ihre personenbezogenen Daten zuzugreifen, sie zu korrigieren oder zu löschen. Kontaktieren Sie uns unter [Ihre E-Mail-Adresse] für Anfragen.</p>

    <h2>7. Kontaktieren Sie uns</h2>
    <p>Bei Fragen senden Sie uns eine E-Mail an <a href="mailto:Ihre&#64;E-Mail-Adresse">{{companyInfo?.email}}</a>.</p>
  </div>
</section>